module.exports = __webpack_public_path__ + "img/packages/top_row_tablet.5fd739.png";